/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
export type GQLDocumentDefaultsFieldsFragment = {
	__typename: "IdentityTeamMember";
	id: string;
	preferences: {
		__typename: "IdentityTeamMemberPreferences";
		sellingAgentCommission: string | null;
		listingPeriod: string | null;
		docusignCarbonCopy: Array<string>;
		agentCommission: string | null;
		mlsPreferences: Array<{
			__typename: "IdentityTeamMemberMlsPreference";
			primary: boolean;
			mls: {
				__typename: "MlsVendor";
				id: string;
				vendor: string;
				displayName: string;
			};
		}>;
	} | null;
};

export const DocumentDefaultsFieldsFragmentDoc = gql`
    fragment DocumentDefaultsFields on IdentityTeamMember {
  id
  preferences {
    sellingAgentCommission
    listingPeriod
    docusignCarbonCopy
    agentCommission
    mlsPreferences {
      mls {
        id
        vendor
        displayName
      }
      primary
    }
  }
}
    `;
